module.exports = __webpack_public_path__ + "img/fluent-open.790f7106.svg";